/* eslint-disable */
const User = {
    isAuthenticated: localStorage.getItem('immotechToken') !== null || localStorage.getItem('token') !== null,
    isAdmin: localStorage.getItem('role') === "admin",
    token: localStorage.getItem('immotechToken') || localStorage.getItem('token'),
    phoneNumber:localStorage.getItem('phoneNumber'),
    user: JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('admin') || 'null'),
    //supportID: localStorage.getItem('customerSupportId'),
    role:localStorage.getItem('role'),
    getToken () { return User.token },
    getUser () { return User.user },
    getPhoneNumber () {return User.phoneNumber},
    //getSupportID () {return User.supportID},
    getRole() {return User.role},
    
    setUserKey (key, value) {
      return new Promise((resolve, reject) => {
        User.user[key] = value
        localStorage.setItem('user', JSON.stringify(User.user))
        localStorage.setItem('admin', JSON.stringify(User.user))
        resolve()
      })
    },
    
    authenticate(token, user) {
      return new Promise ((resolve, reject) => {
        User.isAuthenticated = true
        user.role === "admin" ? User.isAdmin = true : User.isAdmin = false
        User.token = token
        User.user = user
        User.phoneNumber = user.phoneNumber
        User.role = user.role || "admin"
        
        // Set both token keys for compatibility
        localStorage.setItem('immotechToken', token)
        localStorage.setItem('token', token)
        localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem('admin', JSON.stringify(user))
        localStorage.setItem('phoneNumber', user.phoneNumber || '')
        localStorage.setItem('role', user.role || "admin")
        resolve()
      })
    },
    signout(cb) {
      return new Promise ((resolve, reject) => {
        User.isAuthenticated = false
        User.isAdmin = false
        User.token = null
        User.user = null
        User.phoneNumber = null
        User.role = null
        
        // Clear both token keys
        localStorage.removeItem('immotechToken')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('admin')
        localStorage.removeItem('phoneNumber')
        localStorage.removeItem("role")
        
        // Clear dashboard scroll position on logout for full cleanup
        localStorage.removeItem('dashboard-scroll-x')
        
        resolve()
      })
    }
  }
  
  export { User }